import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import hexToRgba from "hex2rgba";
import { grey3, black } from "@churchofjesuschrist/eden-style-constants";
import { InternalOnlyCardStyled } from "./Card";
const ImageMaskStyled = styled.div.withConfig({
  componentId: "sc-1m4vew7-0"
})(["position:relative;display:inline-flex;vertical-align:top;justify-content:center;align-items:center;width:100%;height:100%;background-color:", ";&::after{content:\"\";position:absolute;left:0;right:0;bottom:0;height:50%;background:linear-gradient( to top,", " 0,", " 100% );", ":focus &,", ":hover &{height:100%;}}@media print{&::after{display:none;}}"], grey3, hexToRgba(black, 0.25), hexToRgba(black, 0), InternalOnlyCardStyled, InternalOnlyCardStyled);

const ImageMask = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ImageMaskStyled, props, children);
};

ImageMask.propTypes = {
  /** Image to mask */
  children: PropTypes.node.isRequired
};
export default ImageMask;